module.exports = __webpack_public_path__ + "img/placket_length.aa0b2bf4.png";